import React from 'react';

import { Flex } from '@rover/kibble/core';
import LoadingShimmer from '@rover/kibble/patterns/LoadingShimmer';

const PetCareDetailsShimmer = (): JSX.Element => (
  <>
    <Flex alignItems="flex-start" marginBottom="6x" gap="4x" flexDirection="column">
      <Flex alignItems="flex-start" gap="2x" width="100%">
        <LoadingShimmer width={64} height={64} borderRadius="50%" ml="0x" />
        <Flex flexDirection="column" flex="1" alignSelf="center" gap="2x">
          <LoadingShimmer width={60} height={20} borderRadius="4px" ml="0x" />
          <LoadingShimmer width="100%" height={16} borderRadius="4px" ml="0x" />
        </Flex>
      </Flex>
    </Flex>

    <Flex flexDirection="column" marginBottom="6x" gap="2x">
      <LoadingShimmer width={80} height={20} borderRadius="4px" ml="0x" />
      <LoadingShimmer width={220} height={16} borderRadius="4px" mb="2x" ml="0x" />
      <LoadingShimmer width="100%" height={40} borderRadius="4px" ml="0x" />
    </Flex>

    <Flex flexDirection="column" marginBottom="6x" gap="2x">
      <LoadingShimmer width={140} height={20} borderRadius="4px" ml="0x" />
      <LoadingShimmer width="100%" height={16} borderRadius="4px" mb="2x" ml="0x" />
      <LoadingShimmer width="100%" height={144} borderRadius="4px" ml="0x" />
    </Flex>
  </>
);

export default PetCareDetailsShimmer;
